/**
 * Data Transfer Object (DTO) for client status.
 * This is the wire format used by the API for both requests and responses.
 */

/**
 * Base DTO enum for client status.
 * Represents the wire format used by the backend API.
 * This is the single source of truth for API communication.
 */
export enum ClientStatusDTO {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

/**
 * Type alias for client status in API requests.
 * Uses the base DTO enum.
 */
export type ClientStatusRequest = ClientStatusDTO;

/**
 * Type alias for client status in API responses.
 * Uses the base DTO enum.
 */
export type ClientStatusResponse = ClientStatusDTO;
